import { FormConfig } from 'components/common/form/FormConfig';
import React, { useMemo } from 'react';
import i18n from 'i18n';
import { FormContent } from 'components/common/form/Form';

export const ChannelGroupNonExpressPassCategoriesForm: React.FC<{
  tenmaxCategoryOptions: SelectOptions[];
}> = ({ tenmaxCategoryOptions }) => {
  const formConfig = useMemo(() => {
    const fieldsBuilder = new FormConfig.FieldsBuilder().addFormikSelect({
      label: i18n.t('channelGroupForm.labels.nonExpressPassCategories'),
      name: 'property.addonProps.nonExpressPassCategories',
      simpleValue: true,
      isMulti: true,
      options: tenmaxCategoryOptions
    });
    return new FormConfig.Builder()
      .addSection(
        new FormConfig.SectionBuilder(fieldsBuilder.build())
          .withTitle(
            i18n.t('channelGroups.titles.nonExpressPassCategoriesContent')
          )
          .build()
      )
      .build();
  }, [tenmaxCategoryOptions]);

  return <FormContent formConfig={formConfig} />;
};
